export default __webpack_public_path__ + "static/media/PAULAS CHOICE INTERVIEW_FINWEB3.b8dd04fa.png";